<template>
  <v-layout
    px-1
    class="small-book-form"
    row
    wrap
    align-content-start
    justify-start
    style="height: 100%; position: relative;"
  >
    <v-flex xs12 lg12 shrink>
      <v-layout column class="destination-container">
        <v-flex style="font-size: 13px;" v-if="booking.state == 'accepted'">
          <b>#{{booking.id}}&nbsp;&nbsp;</b>
          <b>Driver</b>
          {{getDriverNameForBooking()}}
        </v-flex>
        <v-flex>
          <b>Pickup</b>
          {{booking.pickup_location.description}}
        </v-flex>
        <v-flex pt-1 v-if="booking.preassigned_driver != null">
          ⚠️ This booking is preassigned to driver
          <b>{{booking.preassigned_driver.driver.callsign}}</b>
          &nbsp;-&nbsp;
          {{booking.preassigned_driver.driver.name
          .substring(0, 10)
          .replace(" ", "&nbsp;")}} ⚠️ ️
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 style="height: 70%; overflow-y: scroll;">
      <v-flex style="width: 120px;">
        <v-text-field hide-details placeholder="Filter" v-model="driverFilter"/>
      </v-flex>
      <v-layout pt-3>
        <v-flex px-4 v-if="loading">
          <v-progress-linear indeterminate color="yellow darken-2"></v-progress-linear>
        </v-flex>
        <v-flex style="height: 100%;" xs12 v-if="!loading">
          <p v-if="filteredCandidateDrivers.length == 0">No drivers are available for assignment.</p>
          <CandidateDriverList
            @input="setSelectedDriver"
            v-if="filteredCandidateDrivers.length > 0"
            :bookings="bookings"
            :taxis="taxis"
            :candidateDrivers="filteredCandidateDrivers"
            :selectedDriver="selectedDriver"
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-layout>
        <v-flex pt-2>
          <p style="color: red;" v-if="error != null">{{error}}</p>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 style="position: absolute; bottom: 0px; right: 0px;">
      <v-layout pt-3>
        <v-btn
          @click="reassignMode ? reassign() : assign()"
          :disabled="selectedDriver == null"
          color="green lighten-2"
          class="text-none"
        >{{ reassignMode ? 'Reassign' : 'Assign' }}</v-btn>
        <v-btn v-if="!largeMode" icon ripple @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { Overwatch } from "@/components/util/Overwatch.js";

import CandidateDriverList from "@/components/overwatch/CandidateDriverList.vue";

import qs from "qs";
import axios from "axios";
import { setTimeout, clearTimeout } from "timers";

axios.defaults.withCredentials = true;

export default {
  name: "AssignTrip",
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    CandidateDriverList
  },
  props: {
    booking: Object,
    bookings: Array,
    taxis: Array,
    reassignMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filteredCandidateDrivers: function() {
      var booking = this.booking;

      console.log(this.driverFilter);

      var vm = this;

      return this.candidateDrivers.filter(function(c) {

        if (vm.driverFilter != "") {

          if (c.callsign.indexOf(vm.driverFilter) == -1 && c.name.toLowerCase().indexOf(vm.driverFilter.toLowerCase())) {
            return false;
          }
         
        } 

        if (booking.currentTaxi != null) {
          return c.taxi_id != booking.currentTaxi.id;
        }

        return true;
      });
    }
  },
  data() {
    return {
      selectedDriver: null,
      addingCard: false,
      addingPromocode: false,
      loading: true,
      candidateDrivers: [],
      error: null,
      timer: null,
      destroyed: false,
      driverFilter: "",
    };
  },
  mounted: function() {
    console.log(this.booking);

    this.getCandidateDrivers();
  },
  beforeDestroy: function() {
    console.log("Clearing timeout");
    clearTimeout(this.timer);
    this.timer = null;
    this.destroyed = true;
  },
  methods: {
    close() {
      this.$emit("cancel", null);
    },
    success() {
      this.loading = false;
      this.error = null;
      this.$emit("cancel", null);
    },
    failed(error) {
      if (error == "wrong_state") {
        error = "Driver is in wrong state";
      }

      this.error = error;
      this.loading = false;
    },
    assign() {
      this.sendAssignReassign();
    },
    reassign() {
      this.sendAssignReassign();
    },
    sendAssignReassign() {
      var selectedDriver = this.selectedDriver;

      var driver = this.candidateDrivers.find(function(d) {
        return d.id == selectedDriver;
      });

      var url = `${this.$store.state.apiUrl}/overwatch/${
        this.reassignMode ? "reassignTaxi" : "assignTaxi"
      }?taxi_id=${driver.taxi_id}&booking_id=${this.booking.id}`;

      var success = this.success;
      var failed = this.failed;

      // this.loading = true;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            console.log("Success");
            success();
          } else {
            failed(res.data.error);
          }
        })
        .catch(function(err) {
          alert("Error " + err);
          this.loading = false;
        });
    },
    setSelectedDriver(id) {
      if (id == this.selectedDriver) {
        this.selectedDriver = null;
        return;
      }
      this.selectedDriver = id;
    },
    errorGettingCandidateDrivers() {
      this.loading = false;
    },
    gotCandidateDrivers(data) {
      this.candidateDrivers = data.driver_scores;

      this.loading = false;

      console.log("Got candidate drivers");
      console.log(this.candidateDrivers);
    },
    getCandidateDrivers() {
      var url = `${this.$store.state.apiUrl}/overwatch/getCandidateDriversForBooking/${this.booking.id}`;

      console.log(url);

      let gotCandidateDrivers = this.gotCandidateDrivers;
      let errorGettingCandidateDrivers = this.errorGettingCandidateDrivers;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        params: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          gotCandidateDrivers(res.data);

          if (vm.timer != null) {
            clearTimeout(vm.timer);
          }

          if (vm.destroyed) {
            return;
          }

          vm.timer = setTimeout(function() {
            vm.getCandidateDrivers();
          }, 5000);
        })
        .catch(function(err) {
          errorGettingCandidateDrivers();
          console.error(err);

          if (vm.timer != null) {
            clearTimeout(vm.timer);
          }

          if (vm.destroyed) {
            return;
          }

          vm.timer = setTimeout(function() {
            vm.getCandidateDrivers();
          }, 5000);
        });
    },
    getDriverNameForBooking() {
      var taxi = this.booking.currentTaxi;

      if (taxi != null) {
        return taxi.driver.name;
      }
    },
    viasForBookingSimple(b) {
      if (b.destinations != null && b.destinations.length > 1) {
        var viaHTML = "<ul style='padding-left: 0px !important'>";

        for (var i = 1; i < b.destinations.length; i++) {
          viaHTML += `<li>${Overwatch.prettifyAddress(
            b.destinations[i].description
          )}</li>`;
        }

        return viaHTML;
      } else {
        return "</ul>";
      }
    },
    destinationForBooking: function(b) {
      return Overwatch.destinationForBooking(b);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.destination-container {
  font-size: 12px;
  background-color: #eaeaea;
  border-radius: 4px;
  padding: 10px;
}
</style>
